import { useEffect } from "react";
import { BUSINESS, NAV_LINKS } from "#/lib/constants";
import { Logo } from "#/components/shared/Logo";
import { CTAButton } from "#/components/shared/CTAButton";
import { X, Phone, ArrowUpRight } from "lucide-react";

export function MobileMenu({ open, onClose }: { open: boolean; onClose: () => void }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex flex-col bg-graphite lg:hidden">
      <div className="flex items-center justify-between px-5 py-4">
        <Logo className="h-11" />
        <button
          onClick={onClose}
          aria-label="Close menu"
          className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white"
        >
          <X className="h-5 w-5" />
        </button>
      </div>

      <nav className="flex flex-1 flex-col gap-1 px-5 pt-4">
        {NAV_LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            onClick={onClose}
            className="flex items-center justify-between border-b border-white/10 py-4 font-heading text-2xl font-bold text-white no-underline"
          >
            {link.label}
            <ArrowUpRight className="h-5 w-5 text-flame" />
          </a>
        ))}
      </nav>

      <div className="space-y-3 px-5 pb-8">
        <CTAButton href="/quote" variant="flame-bubble" size="lg" className="w-full" onClick={onClose}>
          Get a Free Estimate
        </CTAButton>
        <a
          href={BUSINESS.phoneHref}
          className="flex items-center justify-center gap-2 rounded-lg border border-white/20 py-3.5 text-base font-semibold text-white no-underline"
        >
          <Phone className="h-5 w-5 text-flame" />
          {BUSINESS.phone}
        </a>
      </div>
    </div>
  );
}
